import React from 'react';
import {Row, Col, Button, Glyphicon, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {formatQuantity, BOLD_FONT, formatNumber, formatRange} from '../elements/BaseElement';
import { connect } from 'react-redux';
import SmallTransportDisplay from '../transport/SmallTransportDisplay.jsx';
import ConnectTransportElement from '../linktransport/ConnectTransportElement.jsx';
import EditForm from './EditForm.jsx';
import { createFormData } from '@/util/util.jsx';
import { fromJS, List } from 'immutable';
import {
  changeTransportLink, alterProduct, deleteLink,
  removeDealExpense,
} from '../store/deal.store.js';
import { getDealListWrapper } from '../store/DealsWrapper.js';
import FancyInput from '@/component/form/numinput/index.jsx';
import { handleFormChanged } from '@/store/allaround.store.js';
import { deleteFile } from '../store/files.store';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import AvailableSince, { VERSIONS } from '@/util/version';
import linkArrow from '@/../style/linkarrow.png';
import trash from '../../../../../style/trash.png';
import { EditIcon } from '@/component/blogic/deals/payments/PaymentsContainer';

class ConnectLink extends React.Component {
  constructor(props) {
    super(props);
    this.openModalEdit = this.openModalEdit.bind(this);
    this.closeModalEdit = this.closeModalEdit.bind(this);
    this.yesButtonEdit = this.yesButtonEdit.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
    this.yesButtonDelete = this.yesButtonDelete.bind(this);
    this.initVisibility = this.initVisibility.bind(this);
    this.onBLQuantityChange = this.onBLQuantityChange.bind(this);
    this.state = { showModalEdit: false, hidden: false };
  }

  componentWillMount() {
    this.initVisibility(this.props);
  }

  componentWillReceiveProps(props) {
    this.initVisibility(props);
  }

  onBLQuantityChange(e, val) {
    this.props.handleFormChanged();
    if (this.props.isTransportEdit) {
      this.props.changeTransportLink(
        this.props.defaultValue.get('id'),
        'billLandingQuantity',
        val);
    }
  }

  openModalDelete() {
    this.setState({ showModalDelete: true });
  }

  closeModalDelete() {
    this.setState({ showModalDelete: false });
  }

  yesButtonDelete() {
    this.props.deleteLink();
    this.setState({ showModalDelete: false });
    this.props.handleFormChanged();
  }

  openModalEdit() {
    this.setState({ showModalEdit: true });
  }

  closeModalEdit() {
    this.setState({ showModalEdit: false });
  }

  yesButtonEdit() {
    const formData = createFormData('edit_link');
    formData.noTransportBl = formData.noTransportBl === 'on';
    // если пустое значение то нет этого свойства
    formData.billLadingDate = formData.billLadingDate;
    const links = this.props.product.get(`${this.props.fromType}Link`);
    const link = links.get(this.props.linkIdx).merge(fromJS(formData));
    this.props.alterProduct(this.props.product
      .set(`${this.props.fromType}Link`,
        links.set(this.props.linkIdx, link))
    );
    this.setState({ showModalEdit: false });
  }

  initVisibility(props) {
    if (!props.linkDealsList) {
      getDealListWrapper(props.toType, 'INF');
    } else {
      if (props.defaultValue) {
        const data = props.defaultValue;
        // линк к сделке, т.к. существует id-к для связывания
        if (data.get(`${props.toType}Id`)) {
          const hostDeal = props
            .linkDealsList
            .find(deal => deal.get('id') == data.get(`${props.toType}Id`));
          this.state.hidden = hostDeal ? hostDeal.get('hidden') : true;
        } else {
          // а это линк с транпортом, для которого нет противоположной сделки
          this.state.hidden = false;
        }
      }
    }
  }

  laycanDates(transport) {
    let result = new List();
    if (transport) {
      const ports = transport.get('vesselLoadingPorts', new List());
      if (ports.size) {
        result = ports.map(p => formatRange(p.get('laycanStart'), p.get('laycanEnd')));
      } else {
        result = List.of(formatRange(transport.get('laycanStart'), transport.get('laycanEnd')));
      }
    }
    return result.filter(r => r !== null);
  }

  billLadingDates(transport) {
    let result = new List();
    if (transport) {
      const ports = transport.get('vesselLoadingPorts', new List());
      if (ports.size) {
        result = ports.map(p => formatRange(p.get('billLandingDate') || p.get('onBoardDate')));
      } else {
        result = List.of(formatRange(transport.get('billLandingDate') || transport.get('onBoardDate')));
      }
    }
    return result.filter(r => !!r);
  }

  renderTransportDateItem(dates) {
    return dates.size > 1 ?
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            {dates.map(l => <div>{l}</div>)}
          </Tooltip>
        }
      >
        <span>{dates.get(0)}...</span>
      </OverlayTrigger>
      :
      <span>{dates.get(0)}</span>
  }

  renderTransportDates(dates, label) {
    return dates.size ?
      <span>
        <span
          className="text-primary"
          style={{
            ...BOLD_FONT,
            display: 'inline',
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          {label}:
        </span>
        {this.renderTransportDateItem(dates)}
      </span>
      :
      ''
  }

  render() {
    if (!this.props.defaultValue) {
      return (<div></div>);
    }

    const data = this.props.defaultValue;

    const connectedDealStyle = { };

    if (!data.get('transport')) {
      connectedDealStyle.alignSelf = 'center';
    }
    const transportId = data.get('transport');
    const isBLset = !!parseFloat(data.get('billLandingQuantity'));
    const blDate = data.get('billLadingDate');
    const hasTransport = !!transportId || transportId === 0;
    const noTransportBl = data.get('noTransportBl');
    const showLinkTransport = !hasTransport && !data.get('transportList')
      && !noTransportBl && !isBLset;
    const transport = this.props.transport || (this.props.transports || new List()).find(t => t.get('id') === transportId);
    return (
      <div style={{ display: this.state.hidden ? 'none' : '' }}>
        <Modal
          show={this.state.showModalEdit}
          onHide={this.closeModalEdit}
          dialogClassName="modal-link"
        >
          <Modal.Body bsClass="modal-link-body">
            <EditForm
              homeProduct={data.get(`${this.props.fromType}Product`)}
              foreignProduct={data.get(`${this.props.toType}Product`)}
              productType={data.get(`${this.props.toType}ProductType`)}
              packing={data.get(`${this.props.toType}Packing`)}
              dealFrom={this.props.fromType}
              dealTo={this.props.toType}
              defaultValue={this.props.defaultValue}
            />
          </Modal.Body>
          <Modal.Footer bsClass="modal-link-footer">
            <Button
              onClick={this.closeModalEdit}
              style={{
                width: 71,
              }}
            >
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              onClick={this.yesButtonEdit}
              style={{
                marginLeft: 7,
                width: 71,
              }}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal bsSize="small" show={this.state.showModalDelete} onHide={this.closeModalDelete}>
          <Modal.Body>
            Are you sure you want to delete the link?
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.yesButtonDelete}>Yes</Button>
            <Button onClick={this.closeModalDelete}>No</Button>
          </Modal.Footer>
        </Modal>
        <Row
          style={{
            height: '100%',
            display: 'flex',
            flexGrow: 1,
            zIndex: 3,
          }}
        >
          {this.props.fromType == 'sale' ?
            <Col md={6} style={connectedDealStyle} className={'connected-link'}>
              {this.props.children ? this.props.children : ''}
            </Col>
            : ''}

          <Col
            md={6}
            className={'link-block'}
          >
            <Col
              md={12}
              className={'link-middle-block'}
              style={{
                // eslint-disable-next-line
                padding: data.get('transportList') ? '0 0 40px 0' :
                  // eslint-disable-next-line
                  (isBLset && !data.get('transport')) || noTransportBl ? '40px 0' :
                    !data.get('transport') ? '20px 0' : '0',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                margin: 'auto',
                marginTop: showLinkTransport ? 8 : 'auto',
              }}
            >
              <span style={{ display: 'flex', justifyContent: 'center' }}>
                <span
                  name="link"
                  style={{
                    textAlign: 'center',
                    zIndex: 5,
                    height: noTransportBl ? 34 : 'auto',
                    minHeight: 23,
                    marginBottom: !this.props.isTransportEdit ? 4 : 0,
                  }}
                >
                  <span
                    hidden={!data.get('fromMultiNodal')}
                    className={'multinodal-marker'}
                    title={'Link from multi-nodal'}
                  >
                    <Glyphicon glyph="record" />
                  </span>
                  <AvailableSince version={VERSIONS.VasyaFinal}>
                    {this.props.isTransportEdit
                    && (data.get('purchaseProduct') || data.get('purchaseProduct') === 0)
                    && (data.get('saleProduct') || data.get('saleProduct') === 0) && isBLset &&
                      <span style={{ textAlign: 'center' }}>
                        <Button
                          bsStyle="link"
                          className="btn-link-no-underline-on-hover"
                          style={{ padding: '0' }}
                          onClick={() => {
                            window.location =
                              `/deals/transport/api/exportLink/${data.get('id')}`;  //eslint-disable-line
                          }}
                        >
                          Create shipping documents
                        </Button>
                      </span>
                    }
                  </AvailableSince>
                  {isBLset && !this.props.isTransportEdit
                    ?
                    <span style={{ textAlign: 'center' }}>
                      <span
                        className="text-primary"
                        style={{
                          ...BOLD_FONT,
                          display: 'inline',
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                      B/L
                      </span>
                      {formatNumber(data.get('billLandingQuantity'), '0,0.[000]')}
                      {this.renderTransportDates(this.billLadingDates(transport), "Date")}
                    </span>
                    : ''
                  }
                  {!isBLset && formatQuantity(data, true, false)}
                  {!isBLset && this.renderTransportDates(this.laycanDates(transport), "Lay")}
                  {(!isBLset || noTransportBl) && !this.props.viewMode
                    ?
                    <span>
                      <Button
                        id={`editLink${data.get('id')}`}
                        bsStyle="link"
                        style={{ padding: '0px 0px 4px 5px' }}
                        onClick={this.openModalEdit}
                      >
                        <EditIcon />
                      </Button>
                    </span>
                    : ''
                  }
                  <span>
                    {blDate
                      ?
                      <span
                        style={{ height: 34, display: 'inline-block' }}
                      >
                        <span
                          className="text-primary"
                          style={{
                            ...BOLD_FONT,
                            display: 'inline',
                            paddingLeft: 10,
                            paddingRight: 10,
                          }}
                        >
                        Date
                        </span>
                        {blDate}
                      </span>
                      : ''
                    }
                  </span>
                  {!this.props.viewMode
                    ?
                    <span>
                      <Button
                        id={`deleteLink${data.get('id')}`}
                        bsStyle="link"
                        style={{
                          marginLeft: data.get('billLandingQuantity') > 0 ? '10px' : '2px',
                          padding: 0,
                        }}
                        onClick={this.openModalDelete}
                      >
                        <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
                      </Button>
                    </span>
                    : ''
                  }
                </span>
              </span>
              {hasTransport ?
                <div
                  style={{
                    width: '100%', display: 'flex', flexDirection: 'column',
                    alignSelf: 'center', zIndex: 5, position: 'relative',
                  }}
                >
                  {!this.props.isTransportEdit &&
                    <img
                      className={'link-arrow'} src={linkArrow} alt={''} style={{
                        position: 'absolute',
                        top: '51px',
                        height: 12,
                        zIndex: 2,
                      }}
                    />
                  }
                  <span style={{ width: '85%', margin: 'auto', zIndex: 6 }}>
                    <SmallTransportDisplay
                      viewMode={this.props.viewMode}
                      link={data}
                      type={this.props.fromType}
                      product={this.props.product}
                      productIdx={this.props.productIdx}
                    />
                  </span>
                </div>
                :
                !this.props.isTransportEdit &&
                  <img
                    className={'link-arrow'} src={linkArrow} alt={''} style={{
                      position: 'absolute',
                      bottom: '39px',
                      zIndex: 2,
                    }}
                  />
              }

              {showLinkTransport ?
                <div
                  style={{
                    width: '85%', display: 'flex', flexDirection: 'column',
                    alignSelf: 'center', zIndex: 5,
                  }}
                >
                  <center>
                    <ConnectTransportElement
                      dealId={data.get(`${this.props.fromType}Id`)}
                      fromType={this.props.fromType}
                      fromList={this.props.viewMode}
                      linkIdx={this.props.linkIdx}
                      productIdx={this.props.productIdx}
                      buttonStyle={{ alignSelf: 'center' }}
                      productId={this.props.product ? this.props.product.get('product') : undefined}
                      transportType={this.props.product ?
                        this.props.product.get('transportType') : undefined}
                    />
                  </center>
                </div>
                : ''
              }
              {this.props.isTransportEdit &&
                <img
                  className={'link-arrow'} src={linkArrow} alt={''} style={{ paddingRight: 15 }}
                />
              }
              {this.props.isTransportEdit ?
                <div id="BLQuantity" className={'transport-edit-bl-qty'}>
                  <span>B/L quantity </span>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={3}
                    positive
                    negative={false}
                    type="number"
                    id="BLQuantityInput" name="BLQuantityInput"
                    value={data.get('billLandingQuantity')
                      ? data.get('billLandingQuantity')
                      : ''}
                    disabled={this.props.disabled}
                    onChange={this.onBLQuantityChange}
                  />
                </div>
                : ''
              }
            </Col>
          </Col>
          {!this.props.fromType || this.props.fromType == 'purchase' ?
            <Col md={6} style={connectedDealStyle} className={'connected-link'}>
              {this.props.children ? this.props.children : ''}
            </Col>
            : ''}
        </Row>
      </div>);
  }
}

ConnectLink.propTypes = {
  defaultValue: React.PropTypes.object,
  fromType: React.PropTypes.string,
  toType: React.PropTypes.string,
  startTransportLinking: React.PropTypes.func,
  getTransport: React.PropTypes.func,
  alterProduct: React.PropTypes.func,
  children: React.PropTypes.object,
  viewMode: React.PropTypes.bool,
  product: React.PropTypes.object,
  productIdx: React.PropTypes.number,
  linkIdx: React.PropTypes.number,
  isTransportEdit: React.PropTypes.bool,
  transports: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  changeTransportLink: React.PropTypes.func,
  expensestypes: React.PropTypes.object,
  removeDealBulkExpense: React.PropTypes.func,
  files: React.PropTypes.object,
  transport: React.PropTypes.object,
  deleteFile: React.PropTypes.func,
  deleteLink: React.PropTypes.func,
};
export default connect((state, props) =>
  ({
    linkDealsList: state.getIn(['data', 'deals', 'list', props.toType]),
    isTransportEdit: state.getIn(['allaround', 'dealType']) === 'transport',
    transports: state.getIn(['data', 'deals', 'list', 'transport']),
    expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
    files: state.getIn(['data', 'deals', 'files', 'USUAL'], new List()),
  }),
(dispatch, props) => ({
  alterProduct(data) {
    alterProduct(dispatch, props.productIdx, data);
  },
  deleteLink() {
    deleteLink(dispatch, props.productIdx, props.linkIdx);
  },
  changeTransportLink(linkId, field, value) {
    changeTransportLink(dispatch, linkId, field, value);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  removeDealBulkExpense(productIdx, expenseId) {
    removeDealExpense(dispatch, productIdx, expenseId);
  },
  deleteFile(uuid, idx) {
    deleteFile(dispatch, 'USUAL', uuid, idx);
  },
}))(ConnectLink);
